import { MosaicKey, MosaicParent } from 'react-mosaic-component/lib/types';

export type NestedMosaicParentInitial<T extends MosaicKey> = MosaicParent<T> & {
  first: T | NestedMosaicParentInitial<T>;
  second: T | NestedMosaicParentInitial<T>;
  splitPercentage?: number;
};

export type NestedMosaicParent<T extends MosaicKey> = MosaicParent<T> & {
  first: T | NestedMosaicParent<T>;
  second: T | NestedMosaicParent<T>;
  splitPercentage: number;
};

export type MosaicSplitOptions = {
  first?: MosaicSplitOptions;
  second?: MosaicSplitOptions;
  firstMinSplitType: MosaicSplitType;
  firstMinSplitValue: number;
  secondMinSplitType: MosaicSplitType;
  secondMinSplitValue: number;
  initialSplitPercentage: number;
};

export const EMPTY_TILE_ID = '__EMPTY_TILE__';

export enum MosaicSplitType {
  NUMBER = 'NUMBER', // pixels
  PERCENT = 'PERCENT',
}

export const enum ProjectTileId {
  SIDEBAR = 'PROJECT_SIDEBAR',
  VIEW = 'PROJECT_VIEW',
}

export const enum ProjectSidebarTileId {
  RESOURCES = 'RESOURCES',
  MODELS = 'MODELS',
}

export const enum ProjectDiagramTileId {
  DRAWER = 'PROJECT_DIAGRAM_DRAWER',
  VIEW = 'PROJECT_DIAGRAM_VIEW',
}
